import { render, staticRenderFns } from "./OrderDetailsTabs.vue?vue&type=template&id=221f25b0&"
import script from "./OrderDetailsTabs.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailsTabs.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailsTabs.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports